import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const trigger = event.currentTarget
    const snapshotId = trigger.dataset.snapshotId
    const targetEl = this.element.querySelector(`[data-snapshot-id="${snapshotId}"][data-explainer-modal-target="dialog"]`)
    if (!targetEl) return
    targetEl.showModal()
  }

  close(event) {
    event.preventDefault()
    const dialog = event.currentTarget.closest("dialog")
    if (dialog) dialog.close()
  }

  backdropClick(event) {
    if (event.target.tagName === "DIALOG") event.target.close()
  }
}
